<template>
  <v-container>
    <h2>Inserisci la nuova password</h2>
    <v-row>
      <v-col cols="6">
        <v-text-field
          ref="input"
          label="New Password"
          name="newPasword"
          :type="passwordFieldType"
          :append-icon="passwordIcon"
          v-model="userData.Password"
          @click:append="showPassword()"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          ref="input"
          label="Ripeti Password"
          name="rPassword"
          :type="passwordFieldType"
          :append-icon="passwordIcon"
          v-model="userData.RPassword"
          @click:append="showPassword()"
          filled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="Errors!=''">
        <v-alert
           border="bottom"
          color="red"
          dense
          outlined
          type="error"
              >{{Errors}}</v-alert>
    </v-row>
    <v-row v-if="Alerts!=''">
        <v-alert
           border="bottom"
          color="blue"
          dense
          outlined
          type="info"
              >{{Alerts}}</v-alert>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: ["userData"],
  data: () => ({
    error: null,
    Info: null,  
    passwordIcon: "mdi-lock",
    passwordFieldType: "password",
  }),
  methods: {
    showPassword() {
      this.passwordIcon =
        this.passwordIcon === "mdi-lock" ? "mdi-lock-open-variant" : "mdi-lock";
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
  },
  computed: {
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
    Errors: {
      get() {
        if (
          !this.userData.HasValidPassword() &&
          this.userData.Password.length >= this.userData.MinLenPassword()
        )
          return "La password inserita non rispetta i criteri minimi di sicurezza";
        if (
          !this.userData.PasswordConfirmed() &&
          this.userData.RPassword.length >= this.userData.MinLenPassword()
        )
          return "Le password non corrispondono";
        return "";
      },
    },

    Alerts: {
      get() {
        if (
          !this.userData.HasValidPassword() &&
          this.userData.Password.length > 0
        )
          return "La password deve avere una lunghezza di minimo 8 caratteri e deve contenere sia caratteri numerici che alfabetici";

        return "";
      },
    },
  },
};
</script>